const ticketsLang = {
  menuLabel: 'Tickets',
  configuration: {
    pageTitle: 'Paramétrage des tickets',
    menuLabel: 'Configuration',
    automationMenu: 'Automation',
    references: 'Numérotation',
    notificationMenu: 'Notifications',
    closeMenu: 'Clôture automatique'
  },
  tags: {
    pageTitle: 'Gestion des mots-clés',
    createTitle: 'Création d\'un mot-clé',
    editTitle: 'Modification d\'un mot-clé',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce mot-clé ?',
    label: 'Mot-clé',
    menuLabel: 'Mot-clés'
  },
  categories: {
    pageTitle: 'Gestion des catégories',
    createTitle: 'Création d\'une catégorie',
    editTitle: 'Modification d\'une catégorie',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette catégorie ?',
    label: 'Nom',
    color: 'Couleur',
    menuLabel: 'Catégories'
  },
  templates: {
    pageTitle: 'Gestion des modèles de réponse',
    createTitle: 'Création d\'un modèle de réponse',
    editTitle: 'Modification d\'un modèle de réponse',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce modèle de réponse ?',
    menuLabel: 'Modèles de réponse',
    label: 'Nom',
    message: 'Message',
    insert: 'Insérer la réponse',
    replace: 'Remplacer le message'
  },
  automation: {
    conditions: 'Conditions',
    addCondition: 'Ajouter une condition',
    if: 'si le',
    and: 'Et',
    or: 'Ou',
    subject: 'sujet',
    message: 'message',
    contains: 'contient',
    dontContains: 'ne contient pas',
    actions: 'Actions',
    assignToUser: 'Attributer le ticket à l\'utilisateur :',
    priority: 'Mettre la priorité à :',
    category: 'Attributer la catégorie :',
    tags: 'Attributer les mots-clés :',
    explain: 'Vous avez la possibilité d\'automatiser l\'attribution d\'une catégorie, des mots-clés et d\'un utilisateur lors de la création d\'un ticket via la réception d\'un email.',
    addTitle: 'Création d\'une automatisation',
    editTitle: 'Modification d\'une automatisation',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette automatisation ?',
    list: {
      conditions: 'Conditions',
      users: 'Utilisateur',
      priority: 'Priorité',
      category: 'Catégorie',
      tags: 'Mots-clés'
    }
  },
  comments: {
    add: 'Ajout d\'une note',
    edit: 'Modification d\'une note',
    addResponse: 'Ajout d\'une réponse',
    private: 'Note privée',
    linkedFiles: 'Fichiers joints :'
  },
  mailbox: {
    none: 'Aucune',
    markAsRead: 'Marquer l\'email comme lu',
    deleteMail: 'Supprimer l\'email',
    createTicket: 'Créer une demande de support',
    dontCreateTicket: 'Ne pas traiter la demande',
    treatment: 'Traitement des emails',
    whenMailLoaded: 'Lorsqu\'un email est traité',
    explain1: 'Afin de fonctionner correctement, le système de ticket a besoin d\'une boîte email dédiée.',
    explain2: 'Vous devez ainsi configurer :',
    explain3: 'Le serveur pour réceptionner vos emails :',
    explain4: 'Les emails entrant seront utilisé pour créer des tickets et ajouter des messages aux tickets existants.',
    explain5: 'Le serveur pour envoyer vos emails :',
    explain6: 'Les réponses aux tickets seront envoyées via cette adresse email.',
    mailReceipt: 'Réception des emails',
    serverType: 'Type de serveur',
    serverAddress: 'Adresse du serveur',
    serverSecurity: 'Sécurité',
    serverPort: 'Port',
    serverLogin: 'Login',
    serverPassword: 'Mot de passe',
    mailSend: 'Envoi des emails',
    emailAddress: 'Adresse email',
    smtpAddress: 'Adresse du serveur SMTP'
  },
  ticket: {
    pageTitle: 'Support technique',
    myTicketTitle: 'Support technique',
    listTitle: 'Liste des tickets',
    itemTitle: 'Ticket',

    createTitle: 'Création d\'une demande de support',
    back: 'Retour',
    reply: 'Répondre',
    addComment: 'Ajouter une note',
    new: 'Nouvelle demande de support',
    subject: 'Sujet',
    message: 'Message',
    addFiles: 'Joindre des fichiers',
    status: 'Statut',
    status1: 'En attente d\'attribution',
    status2: 'En cours',
    status3: 'Répondu',
    status4: 'Clôturé',
    lastUpdate: 'Dernière mise à jour',
    closed: 'Clôturer',
    changeStatusMsg: 'Êtes-vous sûr de passer ce ticket au statut',
    all: 'Tout',
    messages: 'Messages',
    comments: 'Notes',
    history: 'Historique',
    noElements: 'Aucun élément',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce ticket ?',
    mergeBtn: 'Fusionner',
    mergeTitle: 'Fusionner avec un autre ticket',
    mergeDestination: 'Ticket de destination',
    mergeExplain1: 'Tous les échanges liés à ce ticket seront rattachés au nouveau ticket et ce ticket sera supprimé.',
    mergeExplain2: 'Attention, cette action est irreversible',
    mergeSameContact: 'Ne rechercher que des tickets du même client ou contact',
    tags: 'Mots-clés',
    allTags: 'Tous les mots-clés',
    category: 'Catégorie',
    attributedTo: 'Attribué à',
    priority: 'Priorité',
    priority1: 'Basse',
    priority2: 'Normale',
    priority3: 'Haute',
    priority4: 'Urgente',
    createdBy: 'Créé par',
    createdAt: 'Date de création',
    reference: 'Référence',
    customer: 'Client',
    contact: 'Contact',
    lastAction: 'Dernière action',
    contentFilter: 'Contenu des échanges',
    notAttributed: 'Non attribuée'
  },
  notifications: {
    create: 'Création d\'un nouveau ticket',
    assign: 'Assignation d\'un ticket à un utilisateur',
    newMessage: 'Nouveau message d\'un client sur un ticket',
    newComment: 'Ajout d\'une note sur un ticket',
    close: 'Clôture d\'un ticket',
    allUser: 'Tous les utilisateurs attribués au support',
    onlyUser: 'Uniquement les utilisateurs suivants',
    explain: 'Vous pouvez personnaliser ici, les différentes notifications qui sont envoyées à vos utilisateurs.',
    toCustom: 'Notification à personnaliser',
    choose: 'Choisissez une notification',
    disabled: 'Désactiver cette notification',
    linkedUser: 'L\'utilisateur attribué à la demande de support recevra obligatoirement une notification.',
    noUser: 'Aucun utilisateur sélectionné',
    customizeMessage: 'Personnalisation du message',
    subject: 'Sujet',
    message: 'Message',
    linkExplain: 'Vous pouvez insérer un lien vers le ticket en utilisant la variable [[TICKET-LINK]]',
    variables: {
      ticketTitle: 'Informations sur le ticket',
      subject: 'Sujet',
      message: 'Message',
      customer: 'Client',
      contact: 'Contact',
      priority: 'Priorité',
      category: 'Catégorie',
      tags: 'Mots-clés',
      user: 'Utilisateur attribué au ticket',
      userTitle: 'Informations sur l\'utilisateur',
      firstname: 'Prénom',
      lastname: 'Nom',
    }
  },
  autoclose: {
    title: 'Clôture des tickets',
    closeAfter: 'Clôturer automatiquement un ticket au bout de',
    closeAfterDay: 'jours sans activité.',
    sendNotification: 'Envoyer une notification au client',
    notifyClose: 'jours avant la côture automatique d\'un ticket.',
    customMessage: 'Personnalisation du message'
  }
}

export default {
  tickets: ticketsLang
}
